import { ProfileColor } from "../../../../dispatch/src/ProfileColor";
import { Checkbox, DataHeader, DataSource, DateRangeFilter, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementProfile extends Layout {
    checkboxDepartmentsExclude: Checkbox;
    checkboxPayeeIdsExclude: Checkbox;
    checkboxReasonCodeExclude: Checkbox;
    dataheaderDriverSettlementProfile: DataHeader;
    dateRangeFilter: DateRangeFilter;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    labelOverrides: Label;
    labelPayeeTitle: Label;
    labelPaymentConfTitle: Label;
    labelRecordsTitle: Label;
    layoutProfileColor: ProfileColor;
    panelGeneral: Panel;
    panelOverrides: Panel;
    panelPayee: Panel;
    panelPaymentConfiguration: Panel;
    panelRecords: Panel;
    panelSections: Panel;
    sourceDriverSettlementProfile: DataSource;
    switchOnlyPayeesActivity: Switch;
    textboxBonusCode: Textbox;
    textboxBonusTaxMethod: Textbox;
    textboxCurrencyType: Textbox;
    textboxDepartment: Textbox;
    textboxDescr: Textbox;
    textboxFrozenPayables: Textbox;
    textboxId: Textbox;
    textboxOverrideFrequency: Textbox;
    textboxPayFrequency: Textbox;
    textboxPayRateMethod: Textbox;
    textboxPayeeIds: Textbox;
    textboxPayeeStatus: Textbox;
    textboxPayeeType: Textbox;
    textboxPaymentMethod: Textbox;
    textboxReasonCode: Textbox;
}
